<template>
  <ul class="popup-login">
    <!-- login -->
    <div class="popup-login__sign">
      <ul class="popup-login__sign__cross">
        <li />
        <li />
      </ul>
      <span>{{ $t('commons.connection.sign-in.sign') }}</span>
    </div>
    <div class="popup-login__signin">
      <form>
        <span>{{ $t('commons.connection.sign-in.rules') }}</span>
        <div>
          <div
            class="combination-error"
            v-if="loginError && isLoading"
          >
            {{ $t('commons.navigation.account.signIn.errors.wrong_combination') }}
          </div>
          <custom-input
            value
            :placeholder="$t('commons.connection.sign-in.placeholder.email')"
            :label="$t('commons.email')"
            :active="true"
            :alert="false"
            @fill-input="updatedEmail"
          >
            <div
              class="error"
              v-if="$v.form.email.$error"
            >
              <span v-if="!$v.form.email.required">{{ $t('commons.navigation.account.signIn.errors.email-required') }}</span>
              <span v-if="!$v.form.email.email">{{ $t('commons.navigation.account.signIn.errors.email-format') }}</span>
            </div>
          </custom-input>

          <custom-input
            type="password"
            value
            :placeholder="$t('commons.connection.sign-in.placeholder.password')"
            :label="$t('commons.password')"
            :active="true"
            :alert="false"
            svg="#icon-eye"
            :clickable-svg="true"
            @fill-input="updatedPassword"
          >
            <div
              class="error"
              v-if="$v.form.password.$error"
            >
              <span
                v-if="!$v.form.password.required || !$v.form.password.minLength"
              >Trop court</span>
            </div>
          </custom-input>
        </div>
        <div class="popup-login__signin__forgot-password">
          <a
            href="/identification/mot-de-passe-oublie"
            class="forgot"
          >{{ $t('commons.connection.sign-in.forget-password') }}</a>
          <a href="/faq#faq-Location en agence | Mon compte">{{ $t('commons.connection.sign-in.cant-login') }}</a>
        </div>

        <rent-button
          @buttonclicked="submitForm()"
          :loading="!loginError && isLoading"
        >
          valider
        </rent-button>
      </form>
    </div>
    <!-- create account -->
    <create-account-message class-name="popup-login__signup" />
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import CustomInput from '../../shared/inputs/CustomInput'
import RentButton from '../../shared/RentButton'
import CreateAccountMessage from '../../shared/CreateAccountMessage'

export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
        redirect: '',
      },
      error: {
        submit: '',
      },
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      loginError: (state) => state.auth.loginError,
      userInfo: (state) => state.user.details,
    }),
  },
  validations: {
    form: {
      email: { required, email },
      password: { required, minLength: minLength(4) },
    },
  },
  components: {
    CustomInput,
    RentButton,
    CreateAccountMessage,
  },
  methods: {
    goToSignUp() {
      window.location.href = '/inscription/particulier'
    },
    updatedEmail(val) {
      this.form.email = val
    },
    updatedPassword(val) {
      this.form.password = val
    },
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        return
      }
      this.isLoading = true
      this.$store.dispatch('auth/POST_LOGIN', this.form)
      if (!this.loginError) {
        this.analytics()
        this.geolid()
      }
    },
    geolid() {
      if (!window.gt) {
        return
      }
      /* eslint-disable */
      gt('sendLead', 'Connexion', {
        'first_name': this.userInfo ? this.userInfo?.first_name : 'null',
        'last_name': this.userInfo ? this.userInfo?.last_name:  'null',
        'address': this.userInfo ? this.userInfo?.address: 'null',
        'email': this.userInfo ? this.userInfo?.email: 'null',
        'phone': this.userInfo ? this.userInfo?.tel : 'null',
        'city': this.userInfo ? this.userInfo?.city : 'null',
        'zip_code': this.userInfo ? this.userInfo?.postal_code : 'null'
      })
      /* eslint-enable */
    },
    analytics() {
      if (!window.dataLayer) {
        return
      }
      const event = 'accountLogin'
      const containerId = window.renaultRent.gtm_id
      const loginStatus = 'N/A'
      const page = window.location.href
      const pageCategory = ''
      const pageTitle = document.querySelector('head title')?.text
      const payload = {
        event,
        containerId,
        loginStatus,
        page,
        pageTitle,
        pageCategory,
      }
      // console.log(payload)
      window.dataLayer.push(payload)
    },
  },
}
</script>

<style lang="scss" scoped>

.combination-error {
  color: $c-error;
  font-size: 1.1rem;
  font-style: normal;
}

.popup-login {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 !important;

  @include teq-breakpoint($medium) {
    flex-direction: row;
  }

  &__sign {
    @include transform(translate(0%, -50%));

    background-color: $orange;
    display: flex;
    left: 0;
    padding: 5px 10px;
    position: absolute;
    top: -5px;

    span {
      @include font-size(14px);

      color: white;
    }

    &__cross {
      align-content: center;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-right: 5px;

      li {
        background-color: white;
        height: 1px;
        width: 12px;

        &:nth-child(2) {
          @include rotate(90deg);

          margin-top: -1px;
        }
      }
    }
  }

  &__signin {
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-bottom: 0;
    padding-top: 0;
    width: 100%;

    @include teq-breakpoint($medium) {
      padding: 20px;
      padding-bottom: 20px;
      padding-top: 20px;
    }

    span {
      @include font-size(12px);

      font-style: italic;
      padding-top: 1rem;

      @include teq-breakpoint($medium) {
        padding-top: initial;
      }
    }

    form {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: space-between;
    }

    &__forgot-password {
      align-items: flex-end;
      display: flex;
      flex-direction: column;

      .forgot {
        margin-bottom: 0.2rem;
      }

      a {
        @include forgot-password;
      }
    }

    @include teq-breakpoint($medium) {
      width: 240px;
    }
  }

  &__signup ::v-deep {
    background-color: black;
    color: white;
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding: 20px;
    padding-bottom: 0;

    @include teq-breakpoint($medium) {
      padding: 20px;
      padding-bottom: 0;
    }

    b,
    h4 {
      font-family: $f-graphie-bold;
    }

    h4 {
      margin: 0 0 15px;

      @include teq-breakpoint($medium) {
        margin: 0 0 20px;
      }
    }

    h5 {
      margin: 0 0 10px;

      @include teq-breakpoint($medium) {
        margin: 0 0 20px;
      }
    }

    b {
      font-size: 1.3rem;
      margin: 0 0 10px;
    }

    li {
      @include font-size(12px);

      line-height: 12px;
      list-style: disc outside none;
      margin: 0 0 15px 15px;
    }

    button {
      flex-grow: 0;
    }
  }
}
</style>
